"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuspenseLoader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const remotion_1 = require("remotion");
const Unblocker = () => {
    const { delayRender, continueRender } = (0, remotion_1.useDelayRender)();
    if (typeof document !== 'undefined') {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, react_1.useLayoutEffect)(() => {
            const handle = delayRender(`Waiting for <Suspense /> of <ThreeCanvas /> to resolve`);
            return () => {
                continueRender(handle);
            };
        }, [continueRender, delayRender]);
    }
    return null;
};
const SuspenseLoader = ({ children }) => {
    return (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(Unblocker, {}), children: children });
};
exports.SuspenseLoader = SuspenseLoader;
